module.exports = __webpack_public_path__ + "media/components/investor/images/opendoor_printable_with_stamp-102f42e30c6ace6a01a3266548de6761.png";